const SET_LOADING = (state, status) => {
  state.loading = status
}

const DISABLE_LOADING = (state) => {
  state.loadingDisabled = true
}

const ENABLE_LOADING = (state) => {
  state.loadingDisabled = false
}

const SET_COUNTRIES = (state, data) => {
  state.countriesCreated = new Date().toString()
  state.countries = data
}

const SET_COUNTRIES_LOADING = (state, loading) => {
  state.countriesLoading = loading
}
const SET_FORCE_LOADED_COUNTRIES = (state, data) => {
  state.forceLoadedCounties = data
}
export default {
  SET_LOADING,
  DISABLE_LOADING,
  ENABLE_LOADING,
  SET_COUNTRIES,
  SET_COUNTRIES_LOADING,
  SET_FORCE_LOADED_COUNTRIES
}



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js